import * as React from "react";
import { Layout } from "../../layout";
import { Routes, Route } from "react-router-dom";
import { PolicyList } from "./list";
import { useAppSelector } from "../../store/hooks";
import { selectOrg } from "../../store/contextSlice";
import { PolicyCreateInitializer } from "./create/initializer";
import { PolicyDetailInitializer } from "./detailInitializer";

const PolicyRoute: React.FC = () => {
  const org = useAppSelector(selectOrg);

  return (
    <Layout key={org}>
      <Routes>
        <Route index element={<PolicyList />} />
        <Route path={`-create/*`} element={<PolicyCreateInitializer />} />
        <Route path={`:policy/*`} element={<PolicyDetailInitializer />} />
      </Routes>
    </Layout>
  );
};

export default PolicyRoute;
